var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgTutorial({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 11,
    viewBox: "0 0 13 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.375 0.0835571H1.62496C1.02913 0.0835571 0.541626 0.571057 0.541626 1.16689V7.66689C0.541626 8.26272 1.02913 8.75023 1.62496 8.75023H5.41663V9.83356H4.33329V10.9169H8.66663V9.83356H7.58329V8.75023H11.375C11.9708 8.75023 12.4583 8.26272 12.4583 7.66689V1.16689C12.4583 0.571057 11.9708 0.0835571 11.375 0.0835571ZM11.375 7.66689H1.62496V1.16689H11.375V7.66689Z",
    fill: "white"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTutorial);
export default __webpack_public_path__ + "static/media/tutorial.4637a436.svg";
export { ForwardRef as ReactComponent };